/**
 * c24Defaults.js
 *
 * Version    : 1.0.0
 * Release    : 9-12-2015
 * License    : Copyright by Check24.de
 */
(function() {
    window._paq = window._paq || [];

    window.c24LpRoot = window.c24LpRoot || '/';
    window.c24MobileDevice = false;
    window.c24DeviceOutput = 'desktop';

    /**
     * Mobile Device Check
     */
    $(function() {
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent)) {
            window.c24MobileDevice = true;
        }
    });

    /**
     * On ready events
     */
    $(document).ready(function() {

        window.c24LpCssLoaded.then(function() {

            // Check if there is a root data field in body
            window.c24LpRoot = $('.div24Main').data('root') || window.c24LpRoot;

            /**
             * Fixed Column Heights
             */
            window.c24EqualColumns();

            /**
             * Do a fade rotator if .c24InfoRotator exist
             */
            $('.c24InfoRotator').each(function() {
                const rotator = $(this);
                const liElements = $('li', rotator);
                if (liElements.length) {
                    rotator.c24Randomize('li');
                    liElements.c24Rotator();
                }
            });

            /**
             * Fixables
             */
            window.c24LpInitializeFixables();

            /**
             * Accordion
             */
            const accordions = $('.c24Accordion');
            if (accordions.length) {
                accordions.c24Accordion();
            }

            // Wraps a div around the tables
            $('.c24Editor table').wrap('<div class="c24TableScroll"></div>');

            /**
             * Fancy Box
             */
            $('.js24Fancy').fancybox({});

            /**
             * Logo slider
             */
            $('.c24Carousel').c24Carousel();

            /**
             * Ads c24Last class to the last cell of a table in the CKeditor
             */
            $('.c24Editor table td:last-child').addClass('c24Last');
            $('.c24Editor table td:first-child').addClass('c24First');
        });
    });
})();
